import {
	Module,
	Mutation,
	Action,
	VuexModule,
	getModule,
} from "vuex-module-decorators";
import { IRootState, store } from "@/store";
import { Module as Mod } from "vuex";
import { AuthModule } from "./Auth";
import { AuthStatus } from "@/types/router";
import axios, { AxiosResponse } from "axios";
import { omniChannelClient, simpleCallCenterClient } from "@/conection/index";
import {
	IUser,
	PartialUser,
	ITypification,
	IEvaluation,
	IChannel,
	ISaveCall,
} from "@/callcenter/omni";
import { alertMessages } from "@/util/consts";
import { AlertModule } from "@/store/modules/Alert";
import { fullName } from "@/util/parse";
import { HistoryModule } from "./History";
import {
	capitalizeFirst,
	fetchRemoteDataClient,
	validateTipification,
} from "@/util/utils";
import { apiPetitions, removeExitDigits } from "@/util/utils";
import { env } from "@/config";
import {
	ISaveCallType,
	ICallData,
	IActiveCall,
	IActiveMongoCall,
	CallDataStatus,
} from "@/types/call";
import { TypificationModalModule, actionType } from "./TypificationModal";
import { IndexType } from "@/types/store";
import { AppModule } from "./app";

@Module({ dynamic: true, namespaced: true, store, name: "calldata" })
export class CallData extends VuexModule implements ICallData {
	constructor(module: Mod<ThisType<ICallData>, IRootState>) {
		super(module);
	}

	Scoring = false;
	Fetched = false;
	IsNewUser = false;
	ActiveCall: ICallData["ActiveCall"] = {
		id: "",
		call_number: "",
		uniqueid: "",
		call_status: undefined,
		resultado: 0,
		call_type: "",
		queue: "",
		call_date: "",
		userChanId: "",
	};
	LoadingSK = false;
	LoadingCallRating = false;
	LoadingCallDelete = false;

	User: PartialUser | undefined;
	Typification: ITypification[] | undefined;
	TypificationFetched = false;
	Channel: IChannel[] | undefined;
	ChannelsFetched = false;
	ErrorAlert = false;
	saveCallType = ISaveCallType.single;
	enableControls = false;
	callDataCount = 0;
	queueCalls = {};
	get scoring() {
		return this.Scoring;
	}

	get fetched() {
		return this.Fetched;
	}
	get activeCall() {
		return this.ActiveCall;
	}
	get user() {
		return this.User;
	}
	get isNewUser() {
		return this.IsNewUser;
	}
	get loadingSK() {
		return this.LoadingSK;
	}
	get getLoadingCallRating() {
		return this.LoadingCallRating;
	}
	get getLoadingCallDelete() {
		return this.LoadingCallDelete;
	}
	get Typifications() {
		return this.Typification;
	}
	get Channels() {
		return this.Channel;
	}
	get fetchedTypification() {
		return this.TypificationFetched;
	}
	get errorAlert() {
		return this.ErrorAlert;
	}
	get getSaveCallType() {
		return this.saveCallType;
	}
	get getenableControls() {
		return this.enableControls;
	}
	get getCallDataCount() {
		return this.callDataCount;
	}
	get getQueueCalls() {
		return this.queueCalls;
	}
	@Mutation
	setErrorAlert(error: boolean) {
		this.ErrorAlert = error;
	}
	@Mutation
	setFetChed(fetched: boolean) {
		this.Fetched = fetched;
	}
	@Mutation
	setActiveCall(ActiveCall: IActiveCall) {
		this.ActiveCall = { ...ActiveCall, resultado: ActiveCall.resultado ?? 0 };
	}

	@Mutation
	setScore(Scoring: boolean) {
		this.Scoring = Scoring;
	}
	@Mutation
	setUser(user: PartialUser | undefined) {
		this.User = user;
	}
	@Mutation
	setIsNewUser(newUser: boolean) {
		this.IsNewUser = newUser;
	}
	@Mutation
	setLoadingSK(loadingSK: boolean) {
		this.LoadingSK = loadingSK;
	}
	@Mutation
	setLoadingCallRating(loading: boolean) {
		this.LoadingCallRating = loading;
	}
	@Mutation
	setLoadingCallDelete(loading: boolean) {
		this.LoadingCallDelete = loading;
	}
	@Mutation
	setTypification(Typification: ITypification[] | undefined) {
		this.Typification = Typification;
	}
	@Mutation
	setTypificationFetched(TypificationFetched: boolean) {
		this.TypificationFetched = TypificationFetched;
	}
	@Mutation
	setChannels(Channel: IChannel[] | undefined) {
		this.Channel = Channel;
	}
	@Mutation
	setChannelsFetched(ChannelsFetched: boolean) {
		this.ChannelsFetched = ChannelsFetched;
	}
	@Mutation
	setSaveCallType(type: ISaveCallType) {
		this.saveCallType = type;
	}
	@Mutation
	setEnableControls(value: boolean) {
		if (env.ValidateTypificationControls) {
			this.enableControls = value;
		}
	}
	@Mutation
	SOCKET_NEW_CALL({ update }: { update: boolean }) {
		if (update) this.callDataCount = this.callDataCount + 1;
		store.dispatch("calldata/updateActiveCall");
	}
	@Mutation
	setCallsInQueue(payload: object) {
		this.queueCalls = payload;
	}
	@Mutation
	SOCKET_CALLS_IN_QUEUE({ data: information }: { data: any }) {
		this.queueCalls = { ...this.queueCalls, ...information };
	}
	@Action
	async updateActiveCall(
		payload:
			| {
					phone?: string;
					force?: boolean;
					data?: IActiveMongoCall;
			  }
			| undefined = undefined
	) {
		if (AuthModule.status == AuthStatus.FULL_AUTHENTICATED) {
			try {
				this.setErrorAlert(false);
				let call: IActiveMongoCall | null = null;
				if (!payload?.data) {
					const callRequest = await omniChannelClient.get<{
						calls: IActiveMongoCall[];
					}>("callHistory", {
						params: {
							agent: AuthModule.user?.id,
						},
					});
					call = callRequest.data.calls.length
						? callRequest.data.calls[0]
						: null;
				} else call = payload.data;

				if (env.remoteLoginBackend !== ":")
					axios
						.post(`${env.remoteLoginBackend}/clients/notify/active-call`, {
							extension: AuthModule.extension,
							call,
						})
						.catch(err =>
							console.log(
								"No se ejecuto la sincronización remota de la llamada activa"
							)
						);

				// const call =
				/* 				callCenterClient({
									method: "post",
									url: payload?.force
										? "controllers/GetAgentActiveCall.php?force=true"
										: "controllers/GetAgentActiveCall.php",
									data: new URLSearchParams({
										extension: AuthModule.extension ?? "",
										agente: AuthModule.code ?? "",
									}),
								})
									.then(async (response: AxiosResponse) => { */
				// => Excute if there is a new call incoming and agent has nothing in form
				if (call && (!this.scoring || payload?.force)) {
					this.loadTypification();
					this.loadChannels();
					this.setLoadingSK(true);
					/* 					const call: IActiveCall = response.data;
										call.call_number = payload?.phone?.length
											? payload.phone
											: call.call_number;
										call.call_number = removeExitDigits(call.call_number);
										call.call_type = capitalizeFirst(call.call_type);
										call.queue = capitalizeFirst(call.queue ?? ""); */
					this.setActiveCall({
						id: call._id,
						call_number: removeExitDigits(
							payload?.phone?.length ? payload.phone : call.phone_number
						),
						call_type: capitalizeFirst(call.callType),
						queue: call.queue ? capitalizeFirst(call.queue) : "No definido",
						uniqueid: call.uniqueid,
						userChanId: call.userChanId,
						call_status: call.status,
						call_date: call?.cDate
							? new Date(call?.cDate).toLocaleString()
							: "",
					});
					this.setScore(true);
					this.setIsNewUser(false);
					this.setEnableControls(true);

					//VERIFICAR SI HAY REGISTRO EL USUARIO EN OMNICANAL
					/* 					const OmniResponse: AxiosResponse = await omniChannelClient({
											method: "get",
											url: env.DynamicUser
												? `client/ba/dynamicByNumber/${call.call_number}`
												: `client/ba/byNumber/${call.call_number}`,
										}); */

					// If active call has active form then fetch it and show in screen
					if (call.status === CallDataStatus.PENDING && call.data2)
						this.updateLastEvaluation({
							mId: call._id,
							sId: 1,
							data: call.data2,
							uid: call.uniqueid,
						});

					// Integrations - Fetch data client if exists env.remoteClientURL
					const newRemoteData = await fetchRemoteDataClient(call.phone_number);

					/* 					if (OmniResponse.status == 200) {
											if (
												OmniResponse.data !== null &&
												OmniResponse.data.data !== null
											) { */
					this.setIsNewUser(false);
					const { customer, _id, dynamicData, identification, channels } =
						call.client;
					console.log("UPDATING USER RIGHT NOW", dynamicData, customer);
					this.setUser({
						customer,
						_id,
						dynamicData,
						identification,
						channels: channels.map(c => ({
							_id: c._id,
							channel: c.channel as any,
							service_id: c.service_id,
						})),
					});

					if (newRemoteData) {
						const { customer: client, ...data } = newRemoteData;
						this.updateDynamicUser({ ...client, ...data });
					}
					/* 						} else {
												const user = newRemoteData
													? newRemoteData
													: {
														customer: {
															first_name: "",
															second_name: "",
															third_name: "",
															last_name: "",
															last_name2: "",
														},
														email: "",
														address: "",
														company_name: "",
													};
												await this.createUser(user);
												await this.updateActiveCall();
												// this.setUser(undefined);
											}
										} */
					this.setLoadingSK(false);
					// => Execute only if there is no call incoming, set evaluation form as empty and clear all
				} else if (!call) {
					this.setUser(undefined);
					this.setEnableControls(false);
					this.setScore(false);
					HistoryModule.setHistoryUser(undefined);
					this.setActiveCall({
						call_number: "",
						uniqueid: "",
						userChanId: "",
						call_status: undefined,
						resultado: 0,
						call_type: "",
						queue: "",
						id: "",
					});
				} /* else if (response.data.request_status === "Error") {
					if (response.data.error_call_code === "790") {
						AuthModule.logoutCallCenter();
						AuthModule.setStatus(AuthStatus.CHAT_AUTHENTICATED);
						AuthModule.setExtension(undefined);
						localStorage.removeItem("CALL_EXTENSION");
						AlertModule.SOCKET_PUSH_NOTIFICATION({
							text: alertMessages.ERROR_SESSION,
							type: "error",
						});
						router.push({ name: "Login" });
					} else {
						AlertModule.SOCKET_PUSH_NOTIFICATION({
							text: response.data.request_message,
							type: "error",
						});
					}
				} */
				/* 					})
									.catch(error => {
										this.setErrorAlert(true);
										coreApi.post("/api/log", {
											error,
										});
									}); */
			} catch (error) {
				console.error(error, "error");
			}
		}
	}
	@Action
	async loadTypification() {
		if (this.TypificationFetched == false) {
			try {
				const OmniResponse: AxiosResponse = await omniChannelClient({
					method: "get",
					url: `tipification/ba/find`,
				});
				if (OmniResponse.status == 200) {
					if (OmniResponse.data !== null && OmniResponse.data.data !== null) {
						this.setTypification(OmniResponse.data.data);
						this.setTypificationFetched(true);
					} else {
						this.setTypification(undefined);
						this.setTypificationFetched(false);
					}
				}
			} catch (error) {
				console.error(error, "error");
			}
		}
	}
	@Action
	async loadChannels() {
		if (this.ChannelsFetched == false) {
			try {
				const OmniResponse: AxiosResponse = await omniChannelClient({
					method: "get",
					url: `channel/ba/find_whatsapp`,
				});
				if (OmniResponse.status == 200) {
					if (OmniResponse.data !== null && OmniResponse.data.data !== null) {
						this.setChannels(OmniResponse.data.data);
						this.setChannelsFetched(true);
					} else {
						this.setChannels(undefined);
						this.setChannelsFetched(false);
					}
				}
			} catch (error) {
				console.error(error, "error");
			}
		}
	}
	@Action
	async updateDynamicUser(Partial: IndexType<string | number | object>) {
		try {
			const OmniResponse: AxiosResponse<{
				value: boolean;
				message: string;
				client: PartialUser;
			}> = await omniChannelClient({
				method: "post",
				url: `client/ba/update_dynamic_profile/${
					// TicketModule.currentTicket?.client[0]?._id ?? this.user?._id
					this.user?._id // updateDynamicUser only is triggered on callcenter events
				}`,
				data: Partial,
			});
			if (OmniResponse.status == 200) {
				/* 				if (TicketModule.currentTicket?.client[0]) {
					const updatedTicket: ITicket = TicketModule.currentTicket;
					updatedTicket.client[0] = OmniResponse.data.client as any;
					TicketModule.upsert(updatedTicket);
				} else { // not required if only is triggered by callcenter */
				this.setUser(OmniResponse.data.client);
				// }
				AlertModule.SOCKET_PUSH_NOTIFICATION({
					text: `Cliente actualizado con éxito!`,
					type: OmniResponse.status < 400 ? "success" : "error",
				});
			} else {
				AlertModule.SOCKET_PUSH_NOTIFICATION({
					text: alertMessages.ERROR_UPDATE,
					type: "error",
				});
			}
		} catch (error) {
			console.error(error, "Update user error");
		}
	}
	@Action
	async updateUser(Partial: PartialUser) {
		try {
			const OmniResponse: AxiosResponse = await omniChannelClient({
				method: "post",
				url: `client/ba/update_profile/${this.user?._id}`,
				data: Partial,
			});
			if (OmniResponse.status == 200) {
				if (this.user && Partial.customer) {
					Partial.customer.full_name = fullName(Partial.customer);
					Partial._id = this.user._id;
					const updatedUser = Object.assign({}, this.user, Partial);
					this.setUser(updatedUser);
				}

				AlertModule.SOCKET_PUSH_NOTIFICATION({
					text: OmniResponse.data.message,
					type: OmniResponse.data.value ? "success" : "error",
				});
			} else {
				AlertModule.SOCKET_PUSH_NOTIFICATION({
					text: alertMessages.ERROR_UPDATE,
					type: "error",
				});
			}
		} catch (error) {
			console.error(error, "Update user error");
		}
	}
	@Action
	async createUser(Partial: PartialUser) {
		Partial.phones = [this.ActiveCall?.call_number];
		Partial.channel = {
			serviceId: this.ActiveCall?.call_number,
		};
		try {
			const OmniResponse: AxiosResponse = await omniChannelClient({
				method: "post",
				url: env.DynamicUser
					? `client/ba/create_dynamic_profile`
					: `client/ba/create_profile`,
				data: Partial,
			});
			if (OmniResponse.status == 200) {
				const { email, address, company_name, customer, _id, dynamicData } =
					OmniResponse.data.client as IUser;
				delete customer["name"];
				this.setUser({
					email,
					address,
					company_name,
					customer,
					_id,
					dynamicData,
				});
				AlertModule.SOCKET_PUSH_NOTIFICATION({
					text: OmniResponse.data.message,
					type: OmniResponse.data.value ? "success" : "error",
				});
				this.setIsNewUser(false);
			} else {
				AlertModule.SOCKET_PUSH_NOTIFICATION({
					text: alertMessages.ERROR_UPDATE,
					type: "error",
				});
			}
		} catch (error) {
			console.error(error, "Update user error");
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: alertMessages.ERROR_UPDATE,
				type: "error",
			});
		}
	}
	@Action
	async sendEvaluation(Payload: any): Promise<{ success: boolean }> {
		try {
			this.setLoadingCallRating(true);
			if (!env.DynamicTypification)
				validateTipification(
					Payload?.Evaluation?.tipificacion,
					Payload?.Evaluation?.tipificacion
				);

			/* 			if (this.isNewUser) {
							AlertModule.SOCKET_PUSH_NOTIFICATION({
								text: alertMessages.ERROR_CALLUSER,
								type: "error",
							});
							return { success: false };
						}
						Payload.queue = this.ActiveCall?.queue;
						const { data2: _, ...PayloadWithOutData2 } = Payload;
						const mysqlResponse = await this.sendMysqlEvaluation(PayloadWithOutData2);
						if (mysqlResponse == undefined) {
							this.setLoadingCallRating(false);
							return { success: false };
						}
						if (
							mysqlResponse.status != 200 &&
							mysqlResponse.data.request_status != "success"
						)
							throw new Error("No se ha podido actualizar"); */

			Object.assign(Payload.Evaluation, {
				data: Payload?.data ? Payload?.data : {},
				data2: Payload.data2 ? Payload?.data2 : {},
				_id: this.activeCall.id,
				status: this.activeCall.call_status,
				end: AppModule.appConfig.call_calification === "single",
			});

			const response: AxiosResponse = await omniChannelClient({
				method: "post",
				url: apiPetitions.createCallHistory,
				data: Payload.Evaluation,
			});
			if (response.status == 200 && response.data.value) {
				//Mandar aborrar la llamada si es single
				/* 				if (this.saveCallType == ISaveCallType.single) {
									const res = await this.deleteMysqlActiveCall(Payload.Evaluation);
									if (!res.success) {
										throw new Error("deleteMysqlActiveCall error");
									}
								} */
				this.updateActiveCall();
				this.setEnableControls(false);
				this.setScore(false);
				HistoryModule.setHistoryUser(undefined);
				this.setActiveCall({
					call_number: "",
					uniqueid: "",
					userChanId: "",
					call_status: undefined,
					resultado: 0,
					call_type: "",
					queue: "Desconocido",
					id: "",
				});
				/* 				if (this.saveCallType != ISaveCallType.saveCall) {
									this.setUser(undefined);
									this.setEnableControls(false);
									this.setScore(false);
									HistoryModule.setHistoryUser(undefined);
									this.setActiveCall({
										call_number: "",
										uniqueid: "",
										call_status: "",
										resultado: 0,
										call_type: "",
										queue: "Desconocido",
										id: ""
									});
									this.setIsNewUser(true);
								} */
				AlertModule.SOCKET_PUSH_NOTIFICATION({
					text: response.data.message,
					type: "success",
				});
				this.setLoadingCallRating(false);
				return { success: true };
			} else {
				AlertModule.SOCKET_PUSH_NOTIFICATION({
					text: alertMessages.ERROR_UPDATE,
					type: "error",
				});
				this.setLoadingCallRating(false);
				return { success: false };
			}
		} catch (error: any) {
			console.error(error.message);
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: alertMessages.ERROR_UPDATE,
				type: "error",
			});
			this.setLoadingCallRating(false);
			return { success: false };
		}
	}
	@Action
	async saveCall(callData: ISaveCall) {
		try {
			const response: AxiosResponse = await simpleCallCenterClient({
				method: "post",
				url: `controllers/guardarllamada.php`,
				data: Object.assign(callData, {
					extension: AuthModule.extension ?? "",
					agente: AuthModule.code ?? "",
				}),
			});

			if (response.data.resultado == "OK") {
				//Consultar registro del cliente
				this.updateActiveCall({ phone: response.data.telefono });
				console.log("REGISTRO ALMACENADO DE LLAMADA SALIENTE: ", response);
			}
		} catch (error: any) {
			console.log(Object.keys(error));
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: "Error al guardar la evaluación, guardarllamada.php",
				type: "warning",
			});
			console.error(error, "Send evaluation error, guardarllamada.php");
		}
	}
	@Action
	async sendMysqlEvaluation(
		Evaluation: IEvaluation
	): Promise<AxiosResponse<any, any> | undefined> {
		try {
			console.log("sendMysqlEvaluation");

			if (!env.DynamicTypification)
				validateTipification(
					Evaluation.tipificacion,
					Evaluation.subtipificacion
				);
			Evaluation.correo = env.DynamicUser
				? this.user?.dynamicData?.email?.toString() ?? ""
				: this.user?.email ?? "";
			Evaluation.direccion = env.DynamicUser
				? this.user?.dynamicData?.address?.toString() ?? ""
				: this.user?.address ?? "";
			Evaluation.nombre_completo = this.user?.customer?.full_name;
			Evaluation.numero_telefono = this.ActiveCall?.call_number;
			Evaluation.uniqueid = this.ActiveCall?.uniqueid;
			if (typeof Evaluation.data !== "string") {
				Evaluation.tipificacion = Evaluation.data?.typification;
				Evaluation.subtipificacion = Evaluation.data?.subtypification;
			}
			// Evaluation.subtipificacion = Evaluation.data["subtypification"];
			Evaluation.data = JSON.stringify(Evaluation.data);
			Evaluation.type = this.saveCallType;
			const mysqlResponse: AxiosResponse = await simpleCallCenterClient({
				method: "post",
				url: `controllers/saveCallEvaluation.php`,
				data: Object.assign(Evaluation, {
					agente: AuthModule.code ? AuthModule.code : "",
					extension: AuthModule.extension ? AuthModule.extension : "",
				}),
			});
			return mysqlResponse;
		} catch (error: any) {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text:
					error.message.indexOf("timeout") > -1
						? "No se ha podido procesar su solicitud, intente en unos segundos"
						: "Error al guardar la evaluación",
				type: "warning",
			});
			console.error(error, "Send evaluation error");
		}
	}

	@Action
	async deleteMysqlActiveCall(
		Evaluation: IEvaluation
	): Promise<{ success: boolean }> {
		try {
			if (!this.ActiveCall?.uniqueid) {
				console.error("NoUniqueID no call to delete, return with error");
				return { success: false };
			}
			this.setLoadingCallDelete(true);
			const res = await omniChannelClient.delete(
				`/callHistory/finish/${this.activeCall.id}`
			);
			/* 			Evaluation.uniqueid = this.ActiveCall?.uniqueid;
						Evaluation.type = this.saveCallType;
						Evaluation.nombre_completo = this.user?.customer?.full_name;
						Evaluation.numero_telefono = this.ActiveCall?.call_number;
						const response = await simpleCallCenterClient({
							method: "post",
							url: `controllers/clearCallEvaluation.php`,
							data: Object.assign(Evaluation, {
								agente: AuthModule.code ? AuthModule.code : "",
								extension: AuthModule.extension ? AuthModule.extension : "",
								validateEvaluation: env.needEvaluationToClearActiveCall,
								queue: this.ActiveCall?.queue,
								callType: this.ActiveCall?.call_type,
								client: this.user?._id,
								phone_number: `${this.ActiveCall?.call_number}`,
								uniqueid: this.ActiveCall.uniqueid,
								agentID: AuthModule.user?.id,
							}),
						}); */
			this.setUser(undefined);
			this.setEnableControls(false);
			this.setScore(false);
			HistoryModule.setHistoryUser(undefined);
			this.setActiveCall({
				call_number: "",
				uniqueid: "",
				userChanId: "",
				call_status: undefined,
				resultado: 0,
				call_type: "",
				queue: "",
				id: "",
			});
			this.setIsNewUser(true);
			this.updateActiveCall();
			this.setLoadingCallDelete(false);
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: res.data.message,
				type: "success",
			});
			return { success: true };
		} catch (error: any) {
			this.setLoadingCallDelete(false);
			console.group("Error al borrar llamada activa, deleteMysqlActiveCall");
			console.debug(error);
			console.groupEnd();

			console.log(Object.keys(error.response));
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: error.isAxiosError
					? error.response.data.message
					: error instanceof Error
					? error.message
					: alertMessages.ERROR_UPDATE,
				type: "error",
			});
			return { success: false };
		}
	}

	@Action
	updateLastEvaluation(payload: {
		sId: number;
		mId: string;
		message?: string;
		data: IndexType<string>;
		uid: string;
	}) {
		const idUpdate =
			payload.sId === TypificationModalModule.idSql
				? payload.sId + 1
				: payload.sId;
		TypificationModalModule.setData(payload.data);
		TypificationModalModule.setIdSql(idUpdate);
		TypificationModalModule.setIdMongo(payload.mId);
		TypificationModalModule.setType(actionType.edit);
		this.setScore(true);
		if (payload.message)
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: payload.message,
				type: "success",
			});
	}
	@Action
	updateCurrentCall(payload: { message: string }) {
		this.updateActiveCall({ force: true });
		if (payload?.message)
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: payload.message,
				type: "success",
			});
	}
	@Action
	async getActiveEvaluation(id: string) {
		const activeForm = await omniChannelClient.get(`/callhistory/find/${id}`);
		this.updateLastEvaluation(activeForm.data);
	}
	@Action
	async updateEvaluation(payload: { form: object; data: object }) {
		/* 		const mysqlResponse = await this.updateMysqlEvaluation(payload);
				if (mysqlResponse == undefined) return;
				if (
					mysqlResponse.status != 200 &&
					mysqlResponse.data.request_status != "success"
				)
					throw new Error("No se ha podido actualizar la calificación de llamada"); */
		const mongoResponse = await this.updateMongoEvaluation({
			...payload,
			status: this.activeCall.call_status as CallDataStatus,
			end: AppModule.appConfig.call_calification === "single",
		});
		if (mongoResponse?.status == 200) {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: "Se ha actualizado la calificación de llamada correctamente!!!",
				type: "success",
			});
			return true;
		} else {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: "No se ha actualizado la calificación de llamada correctamente!!!",
				type: "error",
			});
			return false;
		}
	}

	@Action
	async updateMysqlEvaluation(
		evaluation: any
	): Promise<AxiosResponse<any, any> | undefined> {
		const mysqlResponse: AxiosResponse = await simpleCallCenterClient({
			method: "post",
			url: "controllers/updateClientCall.php",
			data: {
				id: TypificationModalModule.idSql?.toString(),
				dynamicData: JSON.stringify(evaluation),
				...(TypificationModalModule.type === actionType.edit
					? { uniqueid: this.activeCall.uniqueid }
					: {}),
			},
		});
		return mysqlResponse;
	}

	@Action
	async updateMongoEvaluation(evaluation: {
		form: object;
		data: object;
		status: CallDataStatus;
		end: boolean;
	}): Promise<AxiosResponse<any, any> | undefined> {
		const mongoResponse: AxiosResponse = await omniChannelClient({
			method: "post",
			url: apiPetitions.updateCallHistory,
			data: { id: TypificationModalModule.idMongo, ...evaluation },
		});
		return mongoResponse;
	}

	@Action
	async getCallCenterClient(phone: string) {
		//VERIFICAR SI HAY REGISTRO EL USUARIO EN OMNICANAL
		const OmniResponse: AxiosResponse = await omniChannelClient({
			method: "get",
			url: env.DynamicUser
				? `client/ba/dynamicByNumber/${phone}`
				: `client/ba/byNumber/${phone}`,
		});
		if (OmniResponse.status == 200) {
			if (OmniResponse.data !== null && OmniResponse.data.data !== null) {
				this.setIsNewUser(false);
				const {
					email,
					address,
					company_name,
					customer,
					_id,
					dui_nit,
					dynamicData,
					identification,
					channels,
				} = OmniResponse.data.data as IUser;
				delete customer["name"];
				// console.log(customer, "customer enviado");
				this.setUser({
					email,
					address,
					company_name,
					customer,
					_id,
					dui_nit,
					dynamicData,
					identification,
					channels,
				});
			}
		}
	}
}
export const CallDataModule = getModule(CallData);
